import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-af8fcb4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "rootRef",
  class: "header-top-menu"
}
const _hoisted_2 = {
  class: "header-top-menu__measure",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "header-top-menu-title" }
const _hoisted_4 = { class: "header-top-menu__bar" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "header-top-menu-title" }
const _hoisted_7 = { class: "header-top-menu-title" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-arrow-down header-top-menu__more-arrow",
  "aria-hidden": "true"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuList, (item, index) => {
        return (_openBlock(), _createElementBlock("span", {
          key: 'measure-' + item.label,
          ref_for: true,
          ref: (el) => _ctx.setMeasureRef(el, index),
          class: "header-top-menu__item-inner"
        }, [
          (item.icon)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: _normalizeClass(["nav-menu-icon iconfont header-top-menu-icon", 'team-admin-nav-icon-' + item.icon])
              }, null, 2))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_3, _toDisplayString(item.label ? _ctx.$t(item.label) : ''), 1)
        ]))
      }), 128)),
      _createElementVNode("span", {
        ref: "moreMeasureRef",
        class: "header-top-menu__item-inner header-top-menu__more-inner"
      }, _toDisplayString(_ctx.$t('nav.moreTopMenus')), 513)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleMenus, (item) => {
        return (_openBlock(), _createElementBlock("button", {
          key: item.label,
          type: "button",
          class: _normalizeClass(["header-top-menu__item", { 'is-active': item.label === _ctx.activeLabel }]),
          onClick: ($event: any) => (_ctx.emitSelect(item))
        }, [
          (item.icon)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: _normalizeClass(["nav-menu-icon iconfont header-top-menu-icon", 'team-admin-nav-icon-' + item.icon])
              }, null, 2))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_6, _toDisplayString(item.label ? _ctx.$t(item.label) : ''), 1)
        ], 10, _hoisted_5))
      }), 128)),
      (_ctx.overflowMenus.length)
        ? (_openBlock(), _createBlock(_component_el_dropdown, {
            key: 0,
            trigger: "hover",
            class: "header-top-menu__more-dropdown",
            onCommand: _ctx.handleOverflowCommand
          }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.overflowMenus, (item) => {
                    return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                      key: item.label,
                      command: item.label,
                      class: _normalizeClass({ 'is-active': item.label === _ctx.activeLabel })
                    }, {
                      default: _withCtx(() => [
                        (item.icon)
                          ? (_openBlock(), _createElementBlock("i", {
                              key: 0,
                              class: _normalizeClass(["nav-menu-icon iconfont header-top-menu-icon", 'team-admin-nav-icon-' + item.icon])
                            }, null, 2))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", null, _toDisplayString(item.label ? _ctx.$t(item.label) : ''), 1)
                      ]),
                      _: 2
                    }, 1032, ["command", "class"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["header-top-menu__item header-top-menu__more", { 'is-active': _ctx.isActiveInOverflow }])
              }, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('nav.moreTopMenus')), 1),
                _hoisted_8
              ], 2)
            ]),
            _: 1
          }, 8, ["onCommand"]))
        : _createCommentVNode("", true)
    ])
  ], 512))
}